import LangEnum from '../lang/LangEnum';
import { CompactAvailability } from '../modules/products/ProductTypes';
import { TranslateType } from '../modules/translation/translationContext.types';

export const MIN_PASSWORD_LENGTH = 8;

export const whatsapp = {
  phone: '5511972680108', // TO DO: esse número deve vir da api
  phoneWithoutDDI: '11972680108',
  helpMessage: LangEnum.LOGIN_TALK_TO_BRAND_MESSAGE,
  contactMessage: LangEnum.CONTACT_US_MESSAGE,
};

interface WhatsappLinkParams {
  phone: string;
  text: string;
}

export const getWhatsappLink = ({ phone, text }: WhatsappLinkParams) =>
  `https://api.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent(text)}`;

export const getLintToTeceoWhatsappWithHelpText = (translate: TranslateType, errorId: string) =>
  getWhatsappLink({
    phone: whatsapp.phone,
    text: translate(whatsapp.helpMessage, { error: errorId }),
  });

export const TECEO_NEWS_URL = 'https://docs.teceo.co/novidades/overview';
export const TECEO_DOCS_URL = 'https://docs.teceo.co';
export const TECEO_STATUS_URL = 'https://status.teceo.co';

export const availabilityOptions: { id: CompactAvailability }[] = [
  {
    id: CompactAvailability.PRE_ORDER,
  },
  {
    id: CompactAvailability.READY_FOR_DELIVERY,
  },
];

export const DRAWER_WIDTH = 259;
export const DRAWER_WIDTH_MOBILE = 267;
export const TITLE_HEIGHT = 40;

export const ROOT_PAGE_PADDING = 20;
export const ROOT_PAGE_PADDING_FROM_TOPBAR = 16;

export const SIDE_MENU_MARGIN_RIGHT = 16;

export const APP_BAR_HEIGHT_DESKTOP = 64;
export const APP_BAR_HEIGHT_MOBILE = 56;
export const ANNOUNCEMENT_BAR_HEIGHT = 32;

export const DESKTOP_ROOT_PAGE_PADDING_TOP = APP_BAR_HEIGHT_DESKTOP;

export const XLS_FORMAT = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
export const BRAZIL_DDI_CODE = '55';

export const TECEO_MAX_WIDTH = 1600;
export const THREE_SECONDS = 3000;

export const INFINITE_SCROLL_ROOT_MARGIN = '0px 0px 175px 0px';
export const INFINITE_SCROLL_ROOT_MARGIN_EXPLORE = '0px 0px 600px 0px';
